import React from 'react';
import Button from './Button';

interface HeaderProps {
  onViewQuotes?: () => void;
  showQuotes?: boolean;
}

const Header: React.FC<HeaderProps> = ({ onViewQuotes, showQuotes = false }) => {
  return (
    <header className="bg-white/80 backdrop-blur-md shadow-lg border-b border-white/20 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-3 sm:px-4 md:px-6 lg:px-8">
        {/* Mobile Layout - Two rows */}
        <div className="block sm:hidden py-4">
          {/* First row - Logo and title */}
          <div className="flex items-center mb-3">
            <a href="https://custom.exactoline.com" className="block">
              <div className="w-8 h-8 bg-gradient-to-r from-purple-600 to-blue-600 rounded-lg flex items-center justify-center mr-3">
                <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
                </svg>
              </div>
            </a>
            <div className="flex-1 min-w-0">
              <h1 className="text-xl font-bold bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent truncate">
                Exactoline Quote System
              </h1>
            </div>
            <Button
              onClick={() => window.open('https://exactoline.com', '_blank')}
              variant="secondary"
              size="sm"
              className="ml-2 flex-shrink-0"
            >
              Exactoline Home
            </Button>
          </div>
          
          {/* Second row - Subtitle and button */}
          <div className="flex items-center justify-between">
            <p className="text-gray-500 text-xs flex-1 min-w-0 mr-3">
              Upload your STEP files for instant quotes
            </p>
            {onViewQuotes && (
              <Button
                onClick={onViewQuotes}
                variant="secondary"
                size="sm"
                className="flex items-center space-x-1 flex-shrink-0"
              >
                <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                </svg>
                <span className="text-xs">{showQuotes ? 'Hide My Quotes' : 'View My Quotes'}</span>
              </Button>
            )}
          </div>
        </div>

        {/* Desktop Layout - Single row */}
        <div className="hidden sm:flex justify-between items-center py-6">
          <div className="flex items-center">
            <a href="https://custom.exactoline.com" className="block">
              <div className="w-10 h-10 bg-gradient-to-r from-purple-600 to-blue-600 rounded-xl flex items-center justify-center mr-4">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
                </svg>
              </div>
            </a>
            <div>
              <h1 className="text-2xl lg:text-3xl font-bold bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent">
                Exactoline Quote System
              </h1>
              <p className="text-gray-500 text-sm mt-1">Upload your STEP files for instant quotes</p>
            </div>
            <Button
              onClick={() => window.open('https://exactoline.com', '_blank')}
              variant="secondary"
              size="sm"
              className="ml-4"
            >
              Exactoline Home
            </Button>
          </div>
          {onViewQuotes && (
            <Button
              onClick={onViewQuotes}
              variant="secondary"
              className="flex items-center space-x-2"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
              </svg>
              <span>{showQuotes ? 'Hide My Quotes' : 'View My Quotes'}</span>
            </Button>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
